export default __webpack_public_path__ + "static/media/EmailFill.422a849e.svg";